{
  "alert": "Alertă",
  "dismiss": "Revocare"
}